/* eslint-disable no-new */
import Vue from 'vue/dist/vue.esm';

[...document.querySelectorAll('.pillars-container')].forEach(el => {
  new Vue({
    el,
    computed: {
      isDesktop() {
        return window.innerWidth >= 700;
      },
    },
    methods: {
      checkPillarsPosition() {
        const animationElement = document.querySelector('.pillars-container');
        const position = animationElement.getBoundingClientRect();
        let marginTop = 370;
        if (this.isDesktop) {
          marginTop = 150;
        }
        const elementTop = position.top + marginTop;

        if (elementTop < window.innerHeight && position.bottom >= 0) {
          animationElement.classList.add('is-visible');
        }
      },
    },
    mounted() {
      document.addEventListener('DOMContentLoaded', this.checkPillarsPosition);
      window.addEventListener('scroll', this.checkPillarsPosition);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.checkPillarsPosition);
    },
  });
});
